import React from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";

function CampaignListPage(props) {
    return (
        <>
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            detailsHref={"/tenant/details"}
                            objectKeys={["id", "name", "external_id"]}
                            columnTitles={[
                                "ID", "Name", "External ID"
                            ]}
                            pageTitle={"Tenants"}
                            readEndpoint={"tenant/read"}
                            relations={[]}
                            />
        </>
    )
}

export default CampaignListPage;